import { useState } from 'react';

export default function Gallery() {
  const [activeTab, setActiveTab] = useState(0);

  const projects = [
    {
      category: 'Basement Waterproofing',
      image: 'https://static.wixstatic.com/media/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg',
      title: 'Complete Basement Waterproofing',
      description: 'Full interior drainage system with sump pump installation'
    },
    {
      category: 'Crawl Space',
      image: 'https://static.wixstatic.com/media/0184a2_11b9d45baf2d4bc7848cfbf437a7a0e1~mv2_d_3472_2604_s_4_2.jpg/v1/fill/w_800,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_11b9d45baf2d4bc7848cfbf437a7a0e1~mv2_d_3472_2604_s_4_2.jpg',
      title: 'Crawl Space Encapsulation',
      description: 'Vapor barrier installation with moisture control system'
    },
    {
      category: 'Foundation Repair',
      image: 'https://static.wixstatic.com/media/f7a16d_5e87cac436234f7a87f1fab9dc855f1a~mv2_d_2560_1440_s_2.jpg/v1/fill/w_800,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Resized952016112595120717958138001002003.jpg',
      title: 'Foundation Stabilization',
      description: 'Structural repair and waterproofing solution'
    },
    {
      category: 'Dry-Rot Repair',
      image: 'https://static.wixstatic.com/media/0184a2_3cb8677424084a4696994efdd7d9946b~mv2.jpg/v1/fill/w_800,h_600,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_3cb8677424084a4696994efdd7d9946b~mv2.jpg',
      title: 'Subfloor Restoration',
      description: 'Complete dry-rot removal and structural replacement'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Our <span className="text-teal-400">Project Gallery</span>
          </h2>
          <p className="text-lg text-slate-300 max-w-3xl mx-auto">
            See the quality of our waterproofing work and the difference we make for our clients
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
              </div>

              {/* Content Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="inline-block bg-teal-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {project.category}
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">{project.title}</h3>
                <p className="text-sm text-slate-300">{project.description}</p>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 bg-teal-600/0 group-hover:bg-teal-600/10 transition-colors duration-300"></div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-300 mb-4">Want to see more of our completed projects?</p>
          <a
            href="#contact"
            className="inline-flex items-center bg-white text-slate-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-slate-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Schedule a Consultation
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
